import { MetadataStatus } from '../../../common/types';
import { htmlDecode } from '../../../../utils/escape.utils';
import { html, TemplateResult } from 'lit';
import { convertNumberToHtmlSpanWithSecondaryFont } from '../../utils';

function convertMetadataStatusToClassName(status: MetadataStatus): string {
  if (status === MetadataStatus.DELIVERED) {
    return 'success';
  }
  if (status === MetadataStatus.DELIVERED_WITH_ERROR) {
    return 'danger';
  }
  return 'warning';
}

export function metadataStatusRenderer({
  item: { status },
}: {
  item: { status: MetadataStatus };
}): TemplateResult | undefined {
  return html`<span class=${convertMetadataStatusToClassName(status)}>
    ${this.stringsTranslator.getTranslatedMetadataStatus(status)}</span
  >`;
}

export function sentRowsRenderer({ item: { sentRows } }: { item: { sentRows: number } }): string | number {
  return sentRows != null ? convertNumberToHtmlSpanWithSecondaryFont(sentRows) : this.translations.naMessage;
}

export function availableRowsRenderer({ item: { availableRows } }: { item: { availableRows: number } }): string {
  return availableRows != null ? convertNumberToHtmlSpanWithSecondaryFont(availableRows) : this.translations.naMessage;
}

export function errorMessageRowsRenderer(data: any): string {
  return data.item.errorReason == null
    ? this.translations.naMessage
    : html`<gz-tooltip tooltipText="${htmlDecode(data.item.errorReason)}"
        >"${htmlDecode(data.item.errorReason)}"</gz-tooltip
      >`;
}

export function queryExecutionTimeRenderer({
  item: { executionTime },
}: {
  item: { executionTime: number };
}): string | number {
  return executionTime != null
    ? this.dependencies.translateFn('{executionTime} ms', { executionTime })
    : this.translations.naMessage;
}
